import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { connect, useDispatch, useSelector } from 'react-redux'
import { AppState } from '../../redux/states/appState'
import { FabMenuItem } from '@/app/redux/states/overlay'
import { OverlayAction } from '@/app/redux/reducers/overlay'
import './FabButton.scss'
import { layoutActions } from '@Techedge/digitalportal-shared'

const FabButton = (props) => {
	const intl = useIntl()
	const [showMenu, setShowMenu] = useState(false)
	const [filteredMenuItems, setFilteredMenuItems] = useState<FabMenuItem[]>(
		[]
	)
	const [style, setStyle] = useState<Record<string, string>>({})
	const dispatch = useDispatch()
	const ph2Enabled = useSelector(
		(state: AppState) => state.userReducer.user.phase2_enabled
	)
	const componentClass = 'smart-overlay-fab-button'
	const localStorageBreadcrumbKey = 'breadcrumbs'

	const onIcon = () => {
		setShowMenu((value) => !value)
	}

	const onMenuItem = (action: OverlayAction) => {
		props.onMenuItem(action)
		localStorage.setItem(localStorageBreadcrumbKey, window.location.href)
		onIcon()
	}

	useEffect(() => {
		if (ph2Enabled !== undefined || ph2Enabled !== null) {
			dispatch({ type: OverlayAction.FILTER_MENU_ITEMS })
		}
	}, [ph2Enabled, window.location.pathname])

	useEffect(() => {
		if (props.menuItems) {
			document.addEventListener('click', (ev) => {
				let targetClasses = (ev.target as any).classList
				let found = false
				for (let c of targetClasses) {
					found = !found
						? c.includes('fab-button') || c.includes('cu-plus')
						: found
				}
				if (!found) setShowMenu(found)
			})
		}
	}, [props.menuItems])

	useEffect(() => {
		setStyle({})
		if (!!props.bottom) setStyle({ bottom: props.bottom })
	}, [props.bottom])

	useEffect(() => {
		if (props.smartlyPermissionUpdated) {
			setFilteredMenuItems(
				props.menuItems?.filter((item: FabMenuItem) =>
					item.permission(props.user.phase2_enabled)
				)
			)
		}
	}, [
		props.menuItems,
		props.user.phase2_enabled,
		props.smartlyPermissionUpdated,
	])

	return filteredMenuItems?.length && props.smartlyPermissionUpdated ? (
		<div className={componentClass} style={style}>
			<div
				className={`${componentClass}--menu ${showMenu ? '' : 'hide'}`}>
				{filteredMenuItems?.map((item: FabMenuItem, index: number) => {
					return (
						<div
							tabIndex={0}
							role={'button'}
							key={index}
							onClick={onMenuItem.bind(null, item.action)}
							className={`${componentClass}--menu-item`}>
							{item.icon && (
								<i
									className={`cu cu-${item.icon}`}
									style={{ color: 'black' }}></i>
							)}
							{item.iconComponent && (
								<div className="component-icon">
									<item.iconComponent />
								</div>
							)}
							<h3>
								{intl.formatMessage({
									id: item.label,
									defaultMessage: item.label.split('.').pop(),
								})}
							</h3>
						</div>
					)
				})}
			</div>

			<div
				className={`${componentClass}--icon ${
					showMenu ? 'rotate' : ''
				} ${!props.menuItems?.length ? 'loading-permissions' : ''}`}
				onClick={onIcon}
				role="button"
				tabIndex={0}>
				<i className="cu cu-plus"></i>
			</div>
		</div>
	) : null
}

const mapStateToProps = (state: AppState) => ({
	menuItems: state.overlayReducer.menuItems,
	actions: state.permissionsReducer.actions,
	bottom: state.layoutReducer.bottomFabButton,
	user: state.userReducer.user,
})

export default connect(mapStateToProps)(FabButton)
